import { useState, useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import MobileHeader from "./MobileHeader";
import MobileBottomNav from "./MobileBottomNav";
import MobileMenu from "./MobileMenu";
import MobileSearchModal from "./MobileSearchModal";

const PublicLayout = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [installPrompt, setInstallPrompt] = useState(null);

  // Handle PWA install prompt
  useEffect(() => {
    const handleBeforeInstall = (e) => {
      e.preventDefault();
      setInstallPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handleBeforeInstall);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstall);
  }, []);

  const handleInstall = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    const result = await installPrompt.userChoice;
    if (result.outcome === 'accepted') setInstallPrompt(null);
  };

  return (
    <div className="min-h-screen bg-[#0a0a0b]">
      {/* Desktop Header - Hidden on mobile */}
      <div className="hidden lg:block">
        <Header />
      </div>
      
      {/* Mobile Header - Only visible on mobile */}
      <MobileHeader />
      
      {/* Main Content */}
      <main className="pb-20 lg:pb-0 bg-[#0a0a0b]">
        {children}
      </main>
      
      {/* Footer */}
      <div className="hidden lg:block">
        <Footer />
      </div>
      
      {/* Mobile Footer - Simplified */}
      <div className="lg:hidden pb-20 bg-[#0a0a0b]">
        <Footer />
      </div>
      
      {/* Mobile Bottom Navigation */}
      <MobileBottomNav 
        onMenuOpen={() => setMenuOpen(true)}
        onSearchOpen={() => setSearchOpen(true)}
      />
      
      {/* Mobile Menu Overlay */}
      <MobileMenu 
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        installPrompt={installPrompt}
        onInstall={handleInstall}
      />
      
      {/* Mobile Search Modal */}
      <MobileSearchModal 
        isOpen={searchOpen}
        onClose={() => setSearchOpen(false)}
      />
    </div>
  );
};

export default PublicLayout;
